import { dot } from 'mathjs';

const SUMPRODUCT = (x, y) => dot(x, y);

export default SUMPRODUCT;
